module.exports = __webpack_public_path__ + "img/fr.134bee9f.png";